import { Component, OnInit, Inject, ViewChild, ElementRef, Renderer2, AfterViewInit, ChangeDetectorRef, Input, EventEmitter, Output } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { UserService } from '../../../services/user.service';
@Component({
  selector: 'app-custom-dropdown-merchants-bottom.component',
  templateUrl: './custom-dropdown-merchants-bottom.component.html',
  styleUrls: ['./custom-dropdown-merchants-bottom.component.scss']
})
export class CustomDropdownMerchantsBottomComponent implements OnInit {

  model: any = {};

  constructor(
    private bottomSheetRef: MatBottomSheetRef<CustomDropdownMerchantsBottomComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data,
    private userService: UserService
  ) { }


  async ngOnInit() {

    this.model.items = this.data.items;
    this.model.display = this.data.display;
    this.model.selectedItem = this.data.selectedItem;
    this.model.partner = this.data.partner;
    this.model.account = this.data.account;

    this.model.user = this.userService.user;
  }

  changeItem(item: any, redirectTo: string) {
    this.bottomSheetRef.dismiss({ item, redirectTo });
  }

}
